import React, { useState } from "react";
import { SMC_FORM_SCHEMA } from "./smcSchema";
import FileDropZone from "./FileDropZone";

const renderField = (field, value, onChange) => {
  const baseProps = {
    id: field.name,
    name: field.name,
    placeholder: field.placeholder || "",
  };
  switch (field.type) {
    case "textarea":
      return (
        <textarea
          {...baseProps}
          className="smc-textarea"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    case "select":
      return (
        <select
          {...baseProps}
          className="smc-select"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">— select —</option>
          {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      );
    case "tags":
      return <TagsInput value={value || []} onChange={onChange} placeholder={field.placeholder} />;
    case "toggle":
      return (
        <label className={`smc-toggle ${value ? "is-on" : ""}`}>
          <span className="smc-toggle-switch" />
          <span>{value ? "Yes" : "No"}</span>
          <input
            type="checkbox"
            checked={!!value}
            onChange={(e) => onChange(e.target.checked)}
            style={{ display: "none" }}
          />
        </label>
      );
    case "file":
      return (
        <FileDropZone
          value={value}
          onChange={onChange}
          accept={field.accept}
          fieldName={field.name}
        />
      );
    case "datetime-local":
      return (
        <input
          {...baseProps}
          type="datetime-local"
          className="smc-input"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
    case "text":
    default:
      return (
        <input
          {...baseProps}
          type="text"
          className="smc-input"
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
        />
      );
  }
};

const TagsInput = ({ value, onChange, placeholder }) => {
  const [draft, setDraft] = useState("");
  const commit = () => {
    const trimmed = draft.trim().replace(/,$/, "");
    if (trimmed && !value.includes(trimmed)) {
      onChange([...value, trimmed]);
    }
    setDraft("");
  };
  return (
    <div className="smc-tags-wrap">
      {value.map((tag) => (
        <span key={tag} className="smc-tag">
          {tag}
          <span
            className="smc-tag-x"
            onClick={() => onChange(value.filter((t) => t !== tag))}
            role="button"
            aria-label={`Remove ${tag}`}
          >×</span>
        </span>
      ))}
      <input
        type="text"
        className="smc-tag-input"
        placeholder={placeholder || ""}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") {
            e.preventDefault();
            commit();
          }
        }}
        onBlur={commit}
      />
    </div>
  );
};

const TypeForm = ({ typeKey, formData, onChange, errors }) => {
  const schema = SMC_FORM_SCHEMA[typeKey];
  if (!schema) return null;
  return (
    <div className="smc-form">
      <h2 className="smc-form-title">{schema.label}</h2>
      <p className="smc-form-subtitle">{schema.description}</p>
      {schema.fields.map((field) => {
        const value = formData[field.name];
        const err = errors?.[field.name];
        return (
          <div key={field.name} className="smc-field">
            <label className="smc-field-label" htmlFor={field.name}>
              {field.label}
              {field.required && <span className="smc-field-required">*</span>}
            </label>
            {renderField(field, value, (next) => onChange(field.name, next))}
            {field.helpText && <div className="smc-field-help">{field.helpText}</div>}
            {err && <div className="smc-field-error">{err}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default TypeForm;
